import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import "./navbar.css";
import GeoNova from "../../assets/images/gnLogo.png";

function NavBar() {
  const location = useLocation();
  const [isScrollingDown, setIsScrollingDown] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrollingDown(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar
      fixed="top"
      expand="md"
      className={`navBarStyles ${isScrollingDown ? "nav-scrolled" : ""}`}
    >
      <Navbar.Brand as={Link} to="/" className="brand-container">
        <img alt="" src={GeoNova} className="navbarImage" />
        <div className="degrade geonovaText">
          <div className="navText">GEONOVA GAMING</div>
        </div>
      </Navbar.Brand>

      <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler" />

      <Navbar.Collapse id="basic-navbar-nav" className="nav-collapse">
        <Nav activeKey={location.pathname} className="ms-auto" as="ul">
          <Nav.Item as="li">
            <Nav.Link as={Link} to="/" eventKey="/">
              <span className={location.pathname === "/" ? "glitch-text" : ""}>
                Home
              </span>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item as="li">
            <Nav.Link as={Link} to="/games" eventKey="/games">
              <span className={location.pathname === "/games" ? "glitch-text" : ""}>
                Games
              </span>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item as="li">
            <Nav.Link as={Link} to="/news" eventKey="/news">
              <span className={location.pathname === "/news" ? "glitch-text" : ""}>
                News
              </span>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item as="li">
            <Nav.Link as={Link} to="/about" eventKey="/about">
              <span className={location.pathname === "/about" ? "glitch-text" : ""}>
                About
              </span>
            </Nav.Link>
          </Nav.Item>

          {/* <Nav.Item as="li">
            <Nav.Link as={Link} to="/contact" eventKey="/contact">
              <span className={location.pathname === "/contact" ? "glitch-text" : ""}>
                Contact
              </span>
            </Nav.Link>
          </Nav.Item> */}
           <Nav.Item as="li">
            <Nav.Link as={Link} to="/newsletter" eventKey="/newsletter">
              <span className={location.pathname === "/newsletter" ? "glitch-text" : ""}>
                Newsletter
              </span>
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default NavBar;
